module.exports = __webpack_public_path__ + "img/belgium-colorectal-cancer-male.54d6570b.png";